import { render, staticRenderFns } from "./BoxesList.vue?vue&type=template&id=74f855bb&"
import script from "./BoxesList.vue?vue&type=script&lang=js&"
export * from "./BoxesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74f855bb')) {
      api.createRecord('74f855bb', component.options)
    } else {
      api.reload('74f855bb', component.options)
    }
    module.hot.accept("./BoxesList.vue?vue&type=template&id=74f855bb&", function () {
      api.rerender('74f855bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/filters/select/BoxesList.vue"
export default component.exports